import { FINANCIAL_FORECAST_REDUCER_KEY } from "..";

const shouldUseMonthly = (getReducerFunc) => {
  if (!getReducerFunc) {
    return false;
  }

  try {
    const forecastState = getReducerFunc(FINANCIAL_FORECAST_REDUCER_KEY);
    return (
      forecastState?.timeSeriesAssumptions?.primaryPeriodicity === "Monthly"
    );
  } catch (err) {
    return false;
  }
};

export const getPeriodValue = (item, key, getReducerFunc) => {
  if (!item) {
    return 0;
  }

  const useMonthly = shouldUseMonthly(getReducerFunc);
  const dataSource = useMonthly ? item.months : item.years;
  if (!dataSource) {
    return 0;
  }

  const rawValue = dataSource[key] ?? dataSource[String(key)];
  const parsed = Number(rawValue);
  return Number.isFinite(parsed) ? parsed : 0;
};
